import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getCalculatedBeefFootprintByYear } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_BEEF_CALCULATED_FOOTPRINT } from "consts";

export const useGetFootprintingCalculatedBeefFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_BEEF_CALCULATED_FOOTPRINT, farmId, year, isAdmin],
      queryFn: () => getCalculatedBeefFootprintByYear(farmId ?? "", year),
      enabled: enabled && !!farmId && !!year && isLoggedIn && !!carbonProgram?.platformFeatures?.footprinting?.beef,
      queryClient,
      gcTime: 60000,
      staleTime: 0,
      retry: shouldRetryQueryError(),
    })),
  });
};
